define('views/layouts/layout-menu',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    'services/layout',
    'services/events/layout-menu-events',
    // views
    'src/views/click-outside-view',
    'views/parts/menu/menu',
    'views/modules/supervisor/supervisor-icon',
    // templates
    'text!templates/layouts/layout-menu.html'
], function(
    // libs
    _, Backbone, Mustache, U,
    // services
    User,
    LayoutState,
    LayoutMenuEvents,
    // views
    VClickOutside,
    VMenu,
    VSupervisorIcon,
    // templates
    TLayoutMenu
) {

    var VLayoutMenu = VClickOutside.extend({
        template: TLayoutMenu,
        className: "overlay box",
        events: {
            'click .menu-toggle, .ucol-profile-photo img': 'onToggle',
            'click a': 'close',
        },

        regions: {
            profileWrapper: ".menu-profile",
            supervisorIcon: ".supervisor-icon",
            profile: "#menu-profile-list",
            primary: "#menu-primary",
            secondary: "#menu-secondary",
        },

        initialize: function(options) {
            options = this.options = _.extend({}, options);

            _.extend(this, {
                group: options.group,
                role: options.role,
                bindingSources: {
                    group: options.group
                }
            });

            var group = this.group,
                model = this.model = User,
                viewOptions = _.pick(options, ['context', 'onClick']),
                view = this.view = {
                    primary: new VMenu(viewOptions),
                    secondary: new VMenu(viewOptions),
                    profile: new VMenu(viewOptions),
                };

            var clickEvent = { "item:click": this.onItemClick },
                profileItems = view.profile.getCollection();
            this.listenTo(view.primary, clickEvent)
                .listenTo(view.secondary, clickEvent)
                .listenTo(group, { "sync": this.render })
                .listenTo(User, { "change:logo": this.render })
                .listenTo(profileItems, { "update": this.toggleMenuExtendClass });
        },

        render: function() {
            this.initListeners();

            var group = this.group,
                data = Mustache.getContext(
                    _.extend({
                        logoTypeText: User.isLogoText(),
                        isSupervisor: group.isSupervisor(),
                    }, this.options));

            this.$el.empty().append(Mustache.render(this.template, data));

            this.applyBindings();

            this.generateZones();
            var zone = this.zone,
                view = this.view;
            this.assign(view.profile, zone.$profile)
                .assign(view.primary, zone.$primary)
                .assign(view.secondary, zone.$secondary);

            this.renderSupervisorIcon()
                .toggleMenuExtendClass();

            return this;
        },

        renderSupervisorIcon: function() {
            var view = this.view;
            if (this.group.isSupervisor()) {
                var supervisorIcon = view.supervisorIcon || (view.supervisorIcon = new VSupervisorIcon());
                this.assign(supervisorIcon, this.zone.$supervisorIcon);
            }
            return this;
        },

        initListeners: function() {
            this.stopListeningTo(LayoutState)
                .stopListeningTo(LayoutMenuEvents);

            this.listenTo(LayoutState, { 'toggle:menu': this.onToggleMenu })
                .listenTo(LayoutMenuEvents, { 'tab:change': this.onTabChange });
        },

        onToggleMenu: function(model, val) {
            // Backbone event handler receives (model, val), extract val
            var shouldOpen = val !== undefined ? val : !this.isOpened();
            this.toggle(shouldOpen);
        },

        toggle: function(val) {
            this.$el.toggleClass('open', val);
            if (this.isOpened()) {
                this.focus();
            }
            LayoutState.setState('menu', this.isOpened());
            return this;
        },

        close: function() {
            return this.toggle(false);
        },

        isOpened: function() {
            return this.$el.hasClass('open'); // this.opened;
        },

        getPrimary: function() {
            return this.view.primary;
        },

        setPrimary: function(items) {
            this.view.primary.setItems(items);
            return this;
        },

        setSecondary: function(items) {
            this.view.secondary.setItems(items);
            return this;
        },

        getProfile: function() {
            return this.view.profile;
        },

        setProfileItems: function(items) {
            this.view.profile.setItems(items);
            return this;
        },

        removeProfileItem: function(itemId) {
            this.view.profile.removeItem(itemId);
        },

        deactivate: function() {
            var view = this.view;
            view.primary.deactivate();
            view.secondary.deactivate();
        },

        toggleMenuExtendClass: function() {
            var itemsCount = this.view.profile.getItemCount(),
                zone = this.zone.$profileWrapper;
            zone.removeClassPrefix('menu-extend');
            zone.toggleClass('menu-extend-' + itemsCount, itemsCount > 2);
        },

        ////////////
        // EVENTS //
        ////////////
        onToggle: function(e) {
            e.preventDefault();
            this.toggle();
        },

        onItemClick: function(e, item, menu) {
            this.deactivate();
            menu.toggleActive(item, true);
            LayoutMenuEvents.itemClick();
        },

        onClickOutside: function(e) {
            this.close();
        },

        onDisable: function() {
            this.stopListeningTo(LayoutState)
                .stopListeningTo(LayoutMenuEvents);
        },

        onTabChange: function(tabId) {
            this.deactivate();
            this.view.primary.findItem(tabId).set('active', true);
        },

        /**
         * Override VClickOutside callback.
         */
        _onBlur: function(e) {
            if (this.isOpened()) {
                VLayoutMenu.__super__._onBlur.apply(this, arguments);
            }
        },

    });

    return VLayoutMenu;

});

